import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './Edit.less';
import HwzComponent from '../../common/component/HwzComponent';
import { Button, Form, Input, Select, Checkbox, Row, Col, Switch, TreeSelect, Alert, DatePicker } from 'antd';  // 增加 DatePicker
import moment, { Moment } from 'moment';  // 增加 moment
import HwzTitle from '../widget/HwzTitle';
import HwzContentCard from '../widget/HwzContentCard';
import { FormInstance } from 'antd/lib/form';
import { SaveOutlined } from '@ant-design/icons/lib';
import { UserRole, UserRoleList } from '../../common/model/user/UserRole';
import ColorSelectionOption from '../../common/model/base/option/ColorSelectionOption';
import MessageBoxUtil from '../../common/util/MessageBoxUtil';
import Sun from '../../common/model/global/Sun';
import Lang from '../../common/model/global/Lang';
import MatterImage from '../matter/widget/MatterImage';
import InputSize from '../widget/form/InputSize';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import User, { AllowedDeviceType, UserLimitType } from '../../common/model/user/User';
import Moon from '../../common/model/global/Moon';

interface RouteParam {
  uuid: string;
}

interface IProps extends RouteComponentProps<RouteParam> {}

interface IState {
  disableShareValue: boolean;
  disablePublicShareValue: boolean;
  deptTreeData: any[];
  deptLoading: boolean;
  webIpRangeVisible: boolean;
  pcIpRangeVisible: boolean;
  bindWebFeature: boolean;
  bindPcFeature: boolean;
  isAdminUser: boolean;  // 新增：标记是否为admin用户
}

export default class Edit extends HwzComponent<IProps, IState> {
  formRef = React.createRef<FormInstance>();

  createMode: boolean = false;

  user: User = Moon.getSingleton().user;

  currentUser: User = new User(this);

  constructor(props: IProps) {
    super(props);

    this.state = {
      disableShareValue: false,
      disablePublicShareValue: false,
      deptTreeData: [],
      deptLoading: false,
      webIpRangeVisible: false,
      pcIpRangeVisible: false,
      bindWebFeature: false,
      bindPcFeature: false,
      isAdminUser: false  // 初始化
    };
    this.currentUser.role = UserRole.USER;
  }

  componentDidMount() {
    let match = this.props.match;

    this.fetchDeptTreeData();

    if (match.params.uuid) {
      this.createMode = false;
      this.currentUser.uuid = match.params.uuid;
      this.currentUser.httpDetail(() => {
        // 检查是否为admin用户
        const isAdminUser = this.currentUser.username === 'admin';
        
        this.setState({
          disableShareValue: this.currentUser.disableShare || false,
          disablePublicShareValue: this.currentUser.disablePublicShare || false,
          webIpRangeVisible: this.currentUser.allowedDevices?.includes(AllowedDeviceType.WEB) || false,
          pcIpRangeVisible: this.currentUser.allowedDevices?.includes(AllowedDeviceType.PCAPP) || false,
          bindWebFeature: this.currentUser.bindWebFeature || false,
          bindPcFeature: this.currentUser.bindPcFeature || false,
          isAdminUser: isAdminUser  // 设置状态
        });
        // 新增：设置授权截止日期的表单值
        this.setExpirationDateFormValue();
      });
    } else {
      this.createMode = true;
      const allowedDevices = this.getAllowedDevicesInitialValue();
      this.setState({
        webIpRangeVisible: allowedDevices.includes(AllowedDeviceType.WEB),
        pcIpRangeVisible: allowedDevices.includes(AllowedDeviceType.PCAPP),
        bindWebFeature: false,
        bindPcFeature: false,
        isAdminUser: false  // 创建模式默认不是admin
      });
      // 新增：创建模式清空截止日期
      this.formRef.current?.setFieldsValue({ expirationDate: undefined });
      this.updateUI();
    }
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>) {
    if (prevProps.match.params.uuid !== this.props.match.params.uuid) {
      const match = this.props.match;
      if (match.params.uuid) {
        this.createMode = false;
        this.currentUser.uuid = match.params.uuid;
        this.currentUser.httpDetail(() => {
          // 检查是否为admin用户
          const isAdminUser = this.currentUser.username === 'admin';
          
          this.setState({
            disableShareValue: this.currentUser.disableShare || false,
            disablePublicShareValue: this.currentUser.disablePublicShare || false,
            webIpRangeVisible: this.currentUser.allowedDevices?.includes(AllowedDeviceType.WEB) || false,
            pcIpRangeVisible: this.currentUser.allowedDevices?.includes(AllowedDeviceType.PCAPP) || false,
            bindWebFeature: this.currentUser.bindWebFeature || false,
            bindPcFeature: this.currentUser.bindPcFeature || false,
            isAdminUser: isAdminUser  // 设置状态
          });
          // 新增：设置授权截止日期的表单值
          this.setExpirationDateFormValue();
        });
      } else {
        this.createMode = true;
        const allowedDevices = this.getAllowedDevicesInitialValue();
        this.setState({
          webIpRangeVisible: allowedDevices.includes(AllowedDeviceType.WEB),
          pcIpRangeVisible: allowedDevices.includes(AllowedDeviceType.PCAPP),
          bindWebFeature: false,
          bindPcFeature: false,
          isAdminUser: false
        });
        // 新增：创建模式清空截止日期
        this.formRef.current?.setFieldsValue({ expirationDate: undefined });
      }
    }
  }

  // 新增：设置表单中的授权截止日期值
  setExpirationDateFormValue = () => {
    if (this.currentUser.expirationDate) {
      this.formRef.current?.setFieldsValue({
        expirationDate: moment(this.currentUser.expirationDate)
      });
    } else {
      this.formRef.current?.setFieldsValue({ expirationDate: undefined });
    }
  };

  fetchDeptTreeData = () => {
    this.setState({ deptLoading: true });
    
    const requestBody = {
      page: 0,
      pageSize: 1000,
      orderIndex: 'ASC'
    };
    
    fetch('/api/sys/dept/page', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error(`Expected JSON, got ${contentType}`);
      }
      
      return response.json();
    })
    .then(data => {
      const treeData = this.convertDataFromBackend(data);
      const treeSelectData = this.convertToTreeSelectData(treeData);
      
      this.setState({ 
        deptTreeData: treeSelectData,
        deptLoading: false 
      });
    })
    .catch(error => {
      console.error(Lang.t('error.operationFailed', '操作失败'));
      this.setState({ deptLoading: false });
    });
  };

  convertDataFromBackend = (rawData: any): any[] => {
    if (!rawData) {
      return [];
    }
    
    let records: any[] = [];
    
    if (Array.isArray(rawData)) {
      records = rawData;
    } else if (rawData.code === "OK" || rawData.code === "SUCCESS" || rawData.Code === "OK") {
      const dataField = rawData.data || rawData.Data;
      if (dataField) {
        if (Array.isArray(dataField)) {
          records = dataField;
        } else if (dataField && typeof dataField === 'object' && dataField.records && Array.isArray(dataField.records)) {
          records = dataField.records;
        }
      }
    } else if (rawData && typeof rawData === 'object' && rawData.records && Array.isArray(rawData.records)) {
      records = rawData.records;
    } else if (Array.isArray(rawData)) {
      records = rawData;
    }
    
    const processTreeData = (nodes: any[]): any[] => {
      return nodes.map(node => {
        const processedNode = { ...node };
        
        if (processedNode.Children && Array.isArray(processedNode.Children)) {
          processedNode.children = processTreeData(processedNode.Children);
          delete processedNode.Children;
        } else if (processedNode.children && Array.isArray(processedNode.children)) {
          processedNode.children = processTreeData(processedNode.children);
        }
        
        if (processedNode.id) {
          processedNode.key = processedNode.id.toString();
        }
        
        return processedNode;
      });
    };
    
    records = processTreeData(records);
    
    return records;
  };

  convertToTreeSelectData = (nodes: any[]): any[] => {
    if (!nodes || nodes.length === 0) return [];
    
    return nodes.map(node => {
      const treeNode: any = {
        title: node.shortName || node.name || Lang.t('department.idFormat', '部门ID: {0}', node.id),
        value: node.id ? node.id.toString() : '',
        key: node.id ? node.id.toString() : '',
        rawData: node
      };
      
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        treeNode.children = this.convertToTreeSelectData(node.children);
      } else {
        treeNode.children = [];
      }
      
      return treeNode;
    });
  };

  findDeptById = (deptId: string): any => {
    const findInTree = (nodes: any[]): any => {
      for (const node of nodes) {
        if (node.value === deptId) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = findInTree(node.children);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };
    
    return findInTree(this.state.deptTreeData);
  };

  onFinish(values: any) {
    let that = this;
    let user: User = this.user;
    let currentUser: User = this.currentUser;
    
    // 新增：处理授权截止日期
    let expirationDate: Date | null = null;
    if (values.expirationDate) {
      expirationDate = (values.expirationDate as Moment).toDate();
    }
    // 从 values 中删除该字段，避免 assign 时报错
    delete values.expirationDate;
    
    // 如果是admin用户，强制清空部门信息
    if (this.state.isAdminUser) {
      values.deptId = null;
    }
    
    currentUser.assign(values);
    
    if (values.deptId && !this.state.isAdminUser) {
      currentUser.deptId = values.deptId;
      
      const dept = this.findDeptById(values.deptId);
      if (dept) {
        currentUser.deptName = dept.rawData?.name;
        currentUser.deptShortName = dept.rawData?.shortName;
      }
    } else {
      // 清空部门信息
      currentUser.deptId = null;
      currentUser.deptName = '';
      currentUser.deptShortName = '';
    }
  
    // 新增：设置授权截止日期
    currentUser.expirationDate = expirationDate;
  
    const deviceInfo = {
      allowedDevices: values.allowedDevices,
      webAllowedIpRange: values.webAllowedIpRange,
      pcAllowedIpRange: values.pcAllowedIpRange,
      bindWebFeature: values.bindWebFeature,
      bindPcFeature: values.bindPcFeature,
      disableShare: values.disableShare,
      disablePublicShare: values.disablePublicShare,
    };
    
    const spaceInfo = {
      sizeLimit: values.sizeLimit,
      totalSizeLimit: values.totalSizeLimit,
      userLimitType: values.userLimitType || UserLimitType.READ_WRITE,
    };
    
    currentUser.httpSave(
      spaceInfo,
      deviceInfo,
      function () {
        MessageBoxUtil.success(Lang.t('operationSuccess', '操作成功'));

        if (user.uuid === currentUser.uuid) {
          user.assign(currentUser);
        }
        Sun.navigateBack();
      }
    );
  }

  onValuesChange = (changedValues: any, allValues: any) => {
    const newState: Partial<IState> = {};
    
    // 处理部门选择
    if (changedValues.deptId !== undefined) {
      // 如果是admin用户，阻止选择部门并提示
      if (this.state.isAdminUser) {
        // 使用setTimeout确保在下一个事件循环中重置，避免死循环
        setTimeout(() => {
          this.formRef.current?.setFieldsValue({ deptId: null });
        }, 0);
        MessageBoxUtil.error(Lang.t('user.adminDeptChangeError', '内置超级用户为全局权限，禁止修改部门！'));
      }
    }
    
    if (changedValues.disableShare !== undefined && 
        changedValues.disableShare !== this.state.disableShareValue) {
      newState.disableShareValue = changedValues.disableShare;
    }
    
    if (changedValues.disablePublicShare !== undefined && 
        changedValues.disablePublicShare !== this.state.disablePublicShareValue) {
      newState.disablePublicShareValue = changedValues.disablePublicShare;
    }
    
    if (changedValues.allowedDevices !== undefined) {
      const allowedDevices = changedValues.allowedDevices || [];
      const newWebIpRangeVisible = allowedDevices.includes(AllowedDeviceType.WEB);
      const newPcIpRangeVisible = allowedDevices.includes(AllowedDeviceType.PCAPP);
      
      if (newWebIpRangeVisible !== this.state.webIpRangeVisible || 
          newPcIpRangeVisible !== this.state.pcIpRangeVisible) {
        newState.webIpRangeVisible = newWebIpRangeVisible;
        newState.pcIpRangeVisible = newPcIpRangeVisible;
      }
    }
    
    if (changedValues.bindWebFeature !== undefined && 
        changedValues.bindWebFeature !== this.state.bindWebFeature) {
      newState.bindWebFeature = changedValues.bindWebFeature;
    }
    
    if (changedValues.bindPcFeature !== undefined && 
        changedValues.bindPcFeature !== this.state.bindPcFeature) {
      newState.bindPcFeature = changedValues.bindPcFeature;
    }
    
    if (Object.keys(newState).length > 0) {
      this.setState(newState as IState);
    }
    
    this.updateUI();
  };

  getDeptInitialValue() {
    if (this.createMode) {
      return null;
    } else {
      // admin用户始终返回null
      if (this.state.isAdminUser) {
        return null;
      }
      return this.currentUser.deptId || null;
    }
  }

  getAllowedDevicesInitialValue() {
    if (this.createMode) {
      return [AllowedDeviceType.WEB, AllowedDeviceType.PCAPP];
    } else {
      return this.currentUser.allowedDevices || [];
    }
  }

  getBindWebFeatureInitialValue() {
    if (this.createMode) {
      return false;
    } else {
      return this.currentUser.bindWebFeature || false;
    }
  }

  getBindPcFeatureInitialValue() {
    if (this.createMode) {
      return false;
    } else {
      return this.currentUser.bindPcFeature || false;
    }
  }

  getDisableShareInitialValue() {
    if (this.createMode) {
      return false;
    } else {
      return this.currentUser.disableShare || false;
    }
  }

  getDisablePublicShareInitialValue() {
    if (this.createMode) {
      return false;
    } else {
      return this.currentUser.disablePublicShare || false;
    }
  }

  getUserLimitTypeInitialValue() {
    if (this.createMode) {
      return UserLimitType.READ_WRITE;
    } else {
      return this.currentUser.userLimitType || UserLimitType.READ_WRITE;
    }
  }

  getWebAllowedIpRangeInitialValue() {
    if (this.createMode) {
      return null;
    } else {
      return this.currentUser.webAllowedIpRange || this.currentUser.allowedIpRange || null;
    }
  }

  getPcAllowedIpRangeInitialValue() {
    if (this.createMode) {
      return null;
    } else {
      return this.currentUser.pcAllowedIpRange || this.currentUser.allowedIpRange || null;
    }
  }

  render() {
    let that = this;

    let user: User = this.user;
    let currentUser: User = this.currentUser;

    const layout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };

    let editSelf: boolean = false;
    if (!this.createMode && user.uuid === currentUser.uuid) {
      editSelf = true;
    }

    let roleEditable: boolean = false;
    if (
      this.createMode ||
      (user.uuid !== currentUser.uuid && user.role === UserRole.ADMINISTRATOR)
    ) {
      roleEditable = true;
    }

    const userLimitTypeOptions = [
      {
        value: UserLimitType.READ_WRITE,
        label: Lang.t('space.memberRoleReadWrite', '读写权限'),
        description: Lang.t('user.readWriteDesc', '可以上传、预览、下载和删除文件')
      },
      {
        value: UserLimitType.UPLOAD_PREVIEW,
        label: Lang.t('user.uploadPreview', '上传预览权限'),
        description: Lang.t('user.uploadPreviewDesc', '可以上传和预览文件，但不能下载')
      },
      {
        value: UserLimitType.READ_ONLY,
        label: Lang.t('user.readOnly', '只读权限'),
        description: Lang.t('user.readOnlyDesc', '只能下载和预览文件，不能上传和删除改名等')
      }
    ];

    return (
      <div className="page-user-edit">
        <HwzTitle
          name={
            this.createMode
              ? Lang.t('user.createUser', '创建用户')
              : Lang.t('user.editUser', '编辑用户')
          }
        ></HwzTitle>

        <HwzContentCard loading={currentUser.detailLoading}>
          <Form
            {...layout}
            name="basic"
            ref={this.formRef}
            onFinish={this.onFinish.bind(this)}
            onValuesChange={this.onValuesChange}
            initialValues={{
              username: currentUser.username,
              role: currentUser.role,
              sizeLimit: currentUser.space?.sizeLimit,
              totalSizeLimit: currentUser.space?.totalSizeLimit,
              userLimitType: this.getUserLimitTypeInitialValue(),
              allowedDevices: this.getAllowedDevicesInitialValue(),
              bindWebFeature: this.getBindWebFeatureInitialValue(),
              bindPcFeature: this.getBindPcFeatureInitialValue(),
              disableShare: this.getDisableShareInitialValue(),
              disablePublicShare: this.getDisablePublicShareInitialValue(),
              webAllowedIpRange: this.getWebAllowedIpRangeInitialValue(),
              pcAllowedIpRange: this.getPcAllowedIpRangeInitialValue(),
              deptId: this.getDeptInitialValue()
            }}
          >
            {editSelf && (
              <Form.Item
                label={Lang.t('user.avatar', '头像')}
                name="avatarUrl"
              >
                <MatterImage />
              </Form.Item>
            )}

            <Form.Item
              label={Lang.t('user.username', '用户名')}
              name="username"
              rules={[
                { required: true, message: Lang.t('user.enterUsername', '请输入用户名') },
              ]}
            >
              <Input disabled={!this.createMode} />
            </Form.Item>

            {this.createMode && (
              <Form.Item
                label={Lang.t('user.password', '密码')}
                name="password"
                rules={[
                  { required: true, message: Lang.t('user.enterPassword', '请输入密码') },
                ]}
              >
                <Input.Password />
              </Form.Item>
            )}

            {this.createMode && (
              <Form.Item
                name="confirmPassword"
                label={Lang.t('user.confirmPassword', '确认密码')}
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: Lang.t('user.enterPassword', '请输入密码'),
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(Lang.t('user.passwordNotSame', '两次输入不一致！'));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            )}

            <Form.Item
              label={Lang.t('user.role', '角色')}
              name="role"
            >
              <Select disabled={!roleEditable}>
                {UserRoleList.filter(
                  (item: ColorSelectionOption, index: number) => {
                    return item.value !== UserRole.GUEST;
                  }
                ).map((item: ColorSelectionOption, index: number) => {
                  return (
                    <Select.Option key={index} value={item.value}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>

            {/* 部门选择部分 */}
            {!this.state.isAdminUser && (
              <Alert
                message={Lang.t('user.deptSelectWarning', '管理员选择部门，降级为部门管理员，仅有本部门用户管理权限！')}
                type="warning"
                showIcon
                style={{ marginBottom: 16, marginLeft: '25%', width: '75%' }}
              />
            )}

            {this.state.isAdminUser && !this.createMode && (
              <Alert
                message={Lang.t('user.adminDeptWarning', '内置超级用户为全局权限，禁止修改部门！')}
                type="error"
                showIcon
                style={{ marginBottom: 16, marginLeft: '25%', width: '75%' }}
              />
            )}

            <Form.Item
              label={
                <span>
                  {Lang.t('user.department', '归属部门')}
                  {!this.state.isAdminUser && (
                    <Tooltip title={Lang.t('user.deptSelectHint', '管理员选择部门，降级为部门管理员，仅有本部门用户管理权限！')}>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  )}
                </span>
              }
              name="deptId"
            >
              <TreeSelect
                placeholder={
                  this.state.isAdminUser 
                    ? Lang.t('user.adminNoDept', '内置超级用户无部门限制')
                    : Lang.t('user.selectDepartment', '选择部门')
                }
                allowClear
                loading={this.state.deptLoading}
                treeData={this.state.deptTreeData}
                treeDefaultExpandAll
                showSearch
                treeNodeFilterProp="title"
                style={{ width: '100%' }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                fieldNames={{
                  label: 'title',
                  value: 'value',
                  children: 'children'
                }}
                notFoundContent={
                  this.state.deptLoading ? 
                    Lang.t('loading', '加载中...') : 
                    this.state.deptTreeData.length === 0 ?
                      Lang.t('user.noDeptData', '暂无部门数据') :
                      Lang.t('user.noMatchingDept', '未找到匹配的部门')
                }
                disabled={this.state.isAdminUser && !this.createMode}  // 禁用admin用户的部门选择
              />
            </Form.Item>

            {/* 新增：授权截止日期表单项 */}
            <Form.Item
              label={Lang.t('user.expirationDate', '授权截止日期')}
              name="expirationDate"
              tooltip={Lang.t('user.expirationDateHint', '设置用户账号的有效期，到期后自动禁用。不设置表示永久用户。')}
            >
              <DatePicker
                style={{ width: '100%' }}
                placeholder={Lang.t('user.selectExpirationDate', '请选择截止日期')}
                format="YYYY-MM-DD"
                allowClear
                disabledDate={(current) => current && current < moment().startOf('day')}
              />
            </Form.Item>

            {/* 其他表单字段保持不变 */}
            <Form.Item
              label={Lang.t('user.singleFileSizeLimit', '单文件限制')}
              required
              name="sizeLimit"
              rules={[{ required: true, message: Lang.t('inputRequired', '该项必填') }]}
            >
              <InputSize
                className="w200"
                disabled={user.role !== UserRole.ADMINISTRATOR}
              />
            </Form.Item>

            <Form.Item
              label={Lang.t('user.totalFileSizeLimit', '空间限制')}
              required
              name="totalSizeLimit"
              rules={[{ required: true, message: Lang.t('inputRequired', '该项必填') }]}
            >
              <InputSize
                className="w200"
                disabled={user.role !== UserRole.ADMINISTRATOR}
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  {Lang.t('user.userLimitType', '用户限制类型')}
                  <Tooltip title={Lang.t('user.userLimitTypeHint', '设置用户对空间的访问和操作权限')}>
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                  </Tooltip>
                </span>
              }
              name="userLimitType"
            >
              <Select placeholder={Lang.t('user.selectUserLimitType', '请选择用户限制类型')}>
                {userLimitTypeOptions.map(option => (
                  <Select.Option key={option.value} value={option.value}>
                    <div>
                      <div style={{ fontWeight: 'bold' }}>{option.label}</div>
                      <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                        {option.description}
                      </div>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  {Lang.t('user.allowedDevices', '安全登录设置:')}
                  <Tooltip title={Lang.t('user.allowedDevicesHint', '设置登录类型的特征和范围(注：未设置类型限制登录)')}>
                    <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                  </Tooltip>
                </span>
              }
              name="allowedDevices"
            >
              <Checkbox.Group>
                <Row>
                  <Col span={12}>
                    <Checkbox value={AllowedDeviceType.WEB}>
                      {Lang.t('user.webClient', '网页端')}
                    </Checkbox>
                  </Col>
                  <Col span={12}>
                    <Checkbox value={AllowedDeviceType.PCAPP}>{Lang.t('user.pcClient', 'PC端')}</Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>

            {this.state.webIpRangeVisible && (
              <Form.Item
                label={
                  <span>
                    {Lang.t('user.webAllowedIpRange', '网页端IP范围')}
                    <Tooltip
                      title={
                        <div>
                          <div>{Lang.t('user.webIpRangeTip', '网页端允许登录的IP范围，支持CIDR格式，多个范围用逗号分隔，如：192.168.1.0/24,10.0.0.0/16')}</div>
                        </div>
                      }
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  </span>
                }
                name="webAllowedIpRange"
              >
                <Input placeholder="192.168.1.0/24,10.0.0.0/16" />
              </Form.Item>
            )}

            {this.state.pcIpRangeVisible && (
              <Form.Item
                label={
                  <span>
                    {Lang.t('user.pcAllowedIpRange', 'PC端IP范围')}
                    <Tooltip
                      title={
                        <div>
                          <div>{Lang.t('user.pcIpRangeTip', 'PC端允许登录的IP范围，支持CIDR格式，多个范围用逗号分隔，如：192.168.1.0/24,10.0.0.0/16')}</div>
                        </div>
                      }
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  </span>
                }
                name="pcAllowedIpRange"
              >
                <Input placeholder="192.168.1.0/24,10.0.0.0/16" />
              </Form.Item>
            )}

            <Form.Item label={Lang.t('user.bindDeviceFeature', '绑定终端特征')}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="bindWebFeature"
                    valuePropName="checked"
                    noStyle
                  >
                    <Switch 
                      disabled={!this.state.webIpRangeVisible}
                    />
                  </Form.Item>
                  <span style={{ marginLeft: 8 }}>
                    {Lang.t('user.bindWebFeature', '绑定Web端特征')}
                    <Tooltip title={
                      !this.state.webIpRangeVisible 
                        ? Lang.t('user.bindWebFeatureDisabledTip', '请先开启网页端登录权限')
                        : Lang.t('user.bindWebFeatureTip', '网页端开启需要安装安全登录Agent，绑定设备硬件特征')
                    }>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: !this.state.webIpRangeVisible ? '#ccc' : '#1890ff' }} />
                    </Tooltip>
                  </span>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="bindPcFeature"
                    valuePropName="checked"
                    noStyle
                  >
                    <Switch 
                      disabled={!this.state.pcIpRangeVisible}
                    />
                  </Form.Item>
                  <span style={{ marginLeft: 8 }}>
                    {Lang.t('user.bindPcFeature', '绑定PC端特征')}
                    <Tooltip title={
                      !this.state.pcIpRangeVisible 
                        ? Lang.t('user.bindPcFeatureDisabledTip', '请先开启PC端登录权限')
                        : Lang.t('user.bindPcFeatureTip', 'PC端开启需要安装安全登录Agent，绑定设备硬件特征')
                    }>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: !this.state.pcIpRangeVisible ? '#ccc' : '#1890ff' }} />
                    </Tooltip>
                  </span>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item label={Lang.t('user.shareSettings', '分享设置')}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="disableShare"
                    valuePropName="checked"
                    noStyle
                  >
                    <Switch />
                  </Form.Item>
                  <span style={{ marginLeft: 8 }}>
                    {Lang.t('user.disableShare', '禁止分享/转发')}
                    <Tooltip title={Lang.t('user.disableShareHint', '完全禁止用户进行任何形式的分享')}>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  </span>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="disablePublicShare"
                    valuePropName="checked"
                    noStyle
                  >
                    <Switch 
                      disabled={this.state.disableShareValue}
                    />
                  </Form.Item>
                  <span style={{ marginLeft: 8 }}>
                    {Lang.t('user.disablePublicShare', '禁止公开分享')}
                    <Tooltip title={Lang.t('user.disablePublicShareHint', '仅允许私有分享，禁止创建公开分享链接')}>
                      <QuestionCircleOutlined style={{ marginLeft: 4, color: this.state.disableShareValue ? '#ccc' : '#1890ff' }} />
                    </Tooltip>
                  </span>
                </Col>
              </Row>
            </Form.Item>

            <div className="text-right">
              <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                {this.createMode ? Lang.t('create', '创建') : Lang.t('save', '保存')}
              </Button>
            </div>
          </Form>
        </HwzContentCard>
      </div>
    );
  }
}